<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <select
              class="form-control"
              v-model="searchMonth"
              @change="changeSearchMonth"
            >
              <option value disabled>請選擇查詢月份</option>
              <option
                v-for="month in searchMonthList"
                :value="month.value"
                :key="month.value"
              >
                {{ month.label }}
              </option>
            </select>
            <div class="py-3">
              <div v-if="'id' in bonus" class="card">
                <div class="card-header bg-primary text-white">獎金查詢</div>
                <div class="card-body">
                  <p>
                    <span
                      v-html="
                        `月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份`
                      "
                    ></span
                    >： {{ formatMonth(bonus.MRESULTS) }}
                  </p>
                  <p>會員編號： {{ bonus.JPSEQ }}</p>
                  <p>會員資格： {{ bonus.COURSE }}</p>
                  <p>
                    <span
                      v-html="
                        `職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;稱`
                      "
                    ></span
                    >： {{ bonus.POSITION }}
                  </p>
                  <p>
                    <span
                      v-html="
                        `聘&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;階`
                      "
                    ></span
                    >： {{ bonus.RANK }}
                  </p>
                  <p>獎金金額： NT$ {{ bonus.TRANSFAR_TOTAL }} 元</p>
                  <div class="form-group">
                    <a
                      class="btn btn-primary btn-block"
                      :href="bonus.docURL"
                      target="_blank"
                      >獎金明細</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
const sha512 = require("hash.js/lib/hash/sha/512");
import {
  getBusinessMonthList,
  getNumberWithCommas,
} from "../../api/fordaysHelpers";
import { mapGetters } from "vuex";
import MemberLayout from "../../components/member/MemberLayout";
import db from "../../api/db";
export default {
  name: "BonusListScreen",
  components: {
    MemberLayout,
  },
  computed: {
    ...mapGetters(["getAuth"]),
  },
  data() {
    return {
      searchMonth: "",
      searchMonthList: getBusinessMonthList(),
      user: {},
      bonus: {},
    };
  },
  methods: {
    changeSearchMonth() {
      const vm = this;
      const searchMonth = vm.searchMonth;
      const bonusDocId = `${vm.user.SEQ}${searchMonth}`;
      db.doc(`jcommissionout/${searchMonth}/monthData/${bonusDocId}`)
        .get()
        .then(async (doc) => {
          if (!doc.exists) {
            vm.bonus = {};
            return;
          }
          const bonus = doc.data();
          bonus.id = doc.id;
          bonus.RANK = (
            await db.doc(`jranktypeout/${bonus.RANK}`).get()
          ).data().NAME;
          bonus.COURSE = (
            await db.doc(`jqualificationtypeout/${bonus.COURSE}`).get()
          ).data().NAME;
          if (bonus.POSITION == 1) {
            bonus.POSITION = "DR";
          } else if (bonus.POSITION == 2) {
            bonus.POSITION = "LD";
          } else {
            bonus.POSITION = "";
          }
          bonus.TRANSFAR_TOTAL = getNumberWithCommas(bonus.TRANSFAR_TOTAL);
          const FILEID = `${bonus.MRESULTS}_${bonus.JPSEQ}`;
          const MRESULTS = bonus.MRESULTS;
          const HASH = sha512()
            .update(`!~ANDY${FILEID}ENN${MRESULTS}DESIGN!@`)
            .digest("hex");
          bonus.docURL = `${vm.$hostURL}/member/bonus?FILEID=${FILEID}&MRESULTS=${MRESULTS}&H=${HASH}&is_web=1`;
          vm.bonus = bonus;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    formatMonth(str) {
      if (!str) {
        return "";
      }
      return str.substring(0, 4) + "/" + str.substring(4);
    },
  },
  mounted() {
    const vm = this;
    vm.user = vm.getAuth.user;
  },
};
</script>